<template>
  <div
    :id="`${source}_upload_csv_component`"
    class="flex flex-col proxima_nova font-medium text_color"
  >
    <div
      v-if="successfulImport"
      :id="`${source}_uploaded_csv_section`"
      class="flex flex-row justify-between items-center text-sm font-medium bg_white_4 rounded-lg p-2"
    >
      <div id="file_name" class="flex flex-row gap-2 items-center">
        <ThemeImage
          class="size-10"
          :icon="imageNames.CSV_FILE"
          alt="csv_file_uploaded_icon"
        />

        <span>{{
          uploadedFileDetails?.original_filename || "filename.csv"
        }}</span>
      </div>

      <span
        id="replace_action"
        class="font-semibold cursor-pointer"
        @click="handleReplaceClick"
        >Replace</span
      >
    </div>

    <div v-else :id="`${source}_upload_csv_section`">
      <div
        class="upload_container"
        :style="containerStyle"
        @click="openCSVImport"
      >
        <div class="flex flex-row gap-1 text-sm items-center">
          <ThemeImage
            class="size-4 mb-[2px]"
            :icon="imageNames.UPLOAD_GREY"
            alt="upload_icon"
          />
          <span class="font-semibold">Drag & drop</span>
          or
          <span class="font-semibold">Click to upload</span>
        </div>

        <span class="text-xs secondary_color">.csv file only</span>
      </div>
    </div>
  </div>
</template>

<script setup>

import { setupDynamicCSVImporter } from "@/src/utils/csvBoxSetup.js";
import { inject, onMounted, computed, ref } from "vue";
import { imageNames } from "@/src/constants/imageConstants.js";

const props = defineProps({
  source: { type: String, required: true },
  height: { type: String, default: "66.8vh" },
  entityListId: { type: Number, default: -1 },
});

const emit = defineEmits(["importSuccess"]);
const csvBoxState = inject("csvBoxState");
const successfulImport = ref(false);
const uploadedFileDetails = ref(null);

const containerStyle = computed(() => ({
  height: props.height,
}));

const openCSVImport = () => {
  csvBoxState.openCSVImport();
};

const onImportSuccess = (successMessage, data) => {
  successfulImport.value = true;
  emit("importSuccess", successMessage);
  if (data) uploadedFileDetails.value = data;
};

const handleReplaceClick = () => {
  successfulImport.value = false;
};

onMounted(async () => {
  successfulImport.value = false;
  await setupDynamicCSVImporter(
    csvBoxState,
    props.source,
    onImportSuccess,
    (errorMessage) => console.error(errorMessage),
    props.entityListId,
  );
});
</script>

<style scoped>
.upload_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px dashed var(--white-opacity-20);
  background: var(--white-opacity-2);
  cursor: pointer;
}
</style>
